module.exports = __webpack_public_path__ + "img/shoplazza-two-en.2d69a216.png";